
import type { PollCRDT } from "./poll"
import type { Bus } from "./lib/Bus"

const errors: any[] = []
const nativeError = window.console.error
window.console.error = (...args) => {
  nativeError(...args)
  errors.push(args)
}

export function DebugController(props: { pollBus: Bus<PollCRDT> }) {
  return (
    <>
      <h2>Errors</h2>
      <pre>
        <code>{JSON.stringify(errors, null, 2)}</code>
      </pre>
      <h2>Poll State</h2>
      <pre>
        <code>{JSON.stringify(props.pollBus.state.get(), null, 2)}</code>
      </pre>
    </>
  )
}
